<template>
  <component v-if="walletTemplate" :is="walletTemplate" />
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
export default {
  mixins: [appConfigMixins],
  components: {
    default1: () => import('@t/wallet/default1'),
    default2: () => import('@t/wallet/default2')
  },
  computed: {
    walletTemplate() {
      //   return 'default2'
      let defaultTemplate = 'default1'
      try {
        return this._config.app_config.configValue.template.wallet || defaultTemplate
      } catch (e) {
        return defaultTemplate
      }
    }
  },
  async created() {
    //挂单策略配置
    await this.$store.dispatch('wallet/getGuadanCzClConfig')
    await this.$store.dispatch('wallet/getGuadanTxClConfig')
  }
}
</script>
